import { Environment } from './environment'
import isEmpty from 'lodash/isEmpty'

const defer = (cb) => {
  setTimeout(cb, 0)
}

class InternalPendoWrapper {
  constructor () {
    this.initRun = false
    this.guidesEnabled = true
    this.environment = this.getEnvAbbreviation(Environment.current())
  }

  async init (impersonatedUser, loggedInUser, shouldDisableGuides) {
    if (this.initRun) console.warn('[PendoWrapper] init has already been performed.')
    else {
      this.initRun = true
      const guides = !this.guidesEnabled || shouldDisableGuides
      defer(async () => {
        await import(/* webpackChunkName: "Pendo", webpackPrefetch: true */ '../../vendor/pendo')
        this.initializePendo(impersonatedUser, loggedInUser, guides)
      })
    }
  }

  getEnvAbbreviation (env) {
    const envParam = env.toString().toLowerCase()
    if (envParam === 'development') return 'dev'
    else if (envParam !== 'production') return envParam
    else return ''
  }

  prefixEnvironmentName (str) {
    if (this.environment) { return `${this.environment}@${str}` }

    return str
  }

  buildVisitor (loggedInUser) {
    return {
      id: this.prefixEnvironmentName(loggedInUser._email),
      email: loggedInUser._email,
      role: loggedInUser._userRole,
      company_name: loggedInUser._companyName,
      insert_date: loggedInUser._insertDate,
      environment: this.environment || 'prod',
      version: '2.0'
    }
  }

  buildAccountObject (impersonatedUser) {
    return {
      id: this.prefixEnvironmentName(impersonatedUser._companyName),
      company_website: impersonatedUser._companyWebsite,
      user_id: impersonatedUser._userId,
      is_admin: impersonatedUser._isAdmin,
      first_name: impersonatedUser._firstName,
      last_name: impersonatedUser._lastName,
      domestic_pricing_plan_id: impersonatedUser._domesticPricingPlanId,
      international_pricing_plan_id: impersonatedUser._internationalPricingPlanId,
      account_manager_id: impersonatedUser._accountManager,
      support_manager_id: impersonatedUser._customerServiceManager,
      user_role_id: impersonatedUser._userRole,
      store_intergration_names: impersonatedUser._storeIntegrationNames,
      number_of_store_intergrations: impersonatedUser._numberOfIntegrations,
      user_growth_experimnet_Id: impersonatedUser._userGrowthExperimentId,
      when_ready_to_ship: impersonatedUser._whenReadyToShip,
      go_live_status: !impersonatedUser._isDemoUser,
      number_recieved_Wro: impersonatedUser._numberOfRecievedWRO,
      has_credit_card_on_file: impersonatedUser._creditCardOnFile,
      shiping_options_set: impersonatedUser._shipOptionsSet,
      active_rules: impersonatedUser._activeRules,
      has_uro: impersonatedUser._hasURO,
      two_day_enabled: impersonatedUser._twoDayEnabled,
      environment: this.environment || 'prod',
      version: '2.0'
    }
  }

  buildUserObject (impersonatedUser, loggedInUser, additionalVisitor, additionalAccount) {
    let visitor = loggedInUser && this.buildVisitor(loggedInUser)
    let account = impersonatedUser && this.buildAccountObject(impersonatedUser)

    const eCommercePlatform = window.localStorage.getItem('SelectedECommercePlaform')
    if (visitor && eCommercePlatform) {
      visitor.current_ecommerce_platform = eCommercePlatform
    }

    if (additionalVisitor) {
      visitor = {
        ...visitor,
        ...additionalVisitor
      }
    }

    if (additionalAccount) {
      account = {
        ...account,
        ...additionalAccount
      }
    }

    return {
      ...(!isEmpty(visitor) && { visitor }),
      ...(!isEmpty(account) && { account })
    }
  }

  disableGuides () {
    try {
      this.guidesEnabled = false
      if (window.pendo && window.pendo.areGuidesDisabled && !window.pendo.areGuidesDisabled()) {
        window.pendo.setGuidesDisabled(true)
        window.pendo.stopGuides()
      }
    } catch (error) {
    }
  }

  enableGuides () {
    try {
      this.guidesEnabled = true
      if (window.pendo && window.pendo.areGuidesDisabled && window.pendo.areGuidesDisabled()) {
        window.pendo.setGuidesDisabled(false)
        window.pendo.loadGuides()
        window.pendo.startGuides()
      }
    } catch (error) {
    }
  }

  initializePendo (impersonatedUser, loggedInUser, shouldDisableGuides) {
    window.pendo.initialize({
      ...this.buildUserObject(impersonatedUser, loggedInUser),
      disableGuides: !!shouldDisableGuides
    })
  }

  updateUserData (impersonatedUser, loggedInUser, additionalVisitor, additionalAccount) {
    if (this.initRun && window.pendo && window.pendo.updateOptions) {
      window.pendo.updateOptions(
        this.buildUserObject(
          impersonatedUser,
          loggedInUser,
          additionalVisitor,
          additionalAccount
        )
      )
    }
  }

  getGuides () {
    if (this.initRun && window.pendo) {
      return window.pendo.guides || []
    }
    return []
  }
}

export const PendoWrapper = new InternalPendoWrapper()
